import { render, staticRenderFns } from "./ButtonRing.vue?vue&type=template&id=9d07b858&scoped=true&"
import script from "./ButtonRing.vue?vue&type=script&lang=js&"
export * from "./ButtonRing.vue?vue&type=script&lang=js&"
import style0 from "./ButtonRing.vue?vue&type=style&index=0&id=9d07b858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d07b858",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
